import { dispatch } from '../redux/store';
import { apiSlice } from '../redux/slices/apiSlice';

export function setApplicationTransportationPeriodId(transportationPeriodId: string) {
  localStorage.setItem('applicationTransportationPeriodId', transportationPeriodId.toString());
  localStorage.removeItem('applicationSchoolYearId');
  dispatch(apiSlice.util.resetApiState());
}

export function getApplicationTransportationPeriodId() {
  const transportationPeriodId = localStorage.getItem('applicationTransportationPeriodId');
  if (transportationPeriodId !== null) {
    return transportationPeriodId || '0';
  }

  const previousId = localStorage.getItem('applicationSchoolYearId');
  if (previousId !== null) {
    localStorage.setItem('applicationTransportationPeriodId', previousId);
    localStorage.removeItem('applicationSchoolYearId');
    return previousId || '0';
  }

  return '0';
}
